export default __webpack_public_path__ + "public/assets/images/5b7adcfd1ab9d55eee4f9bc1449ea732.png";